import { TaskTimeEntry } from "app/reducers/task/taskDataInterface";
import { FC, useState } from "react";
import TimeDetailsModal from "./TimeDetailsModal";

interface props {
  row: TaskTimeEntry;
}

const TaskTimeReportTableRow: FC<props> = ({ row }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <tr>
        <td className="text-dark fw-bold ps-2">{row.TaskCode}</td>
        <td>{row.TaskTypeName}</td>
        <td>{row.StandardHours}</td>
        <td
          style={{ cursor: "pointer", color: "#009ef7" }}
          onClick={() => setShowModal(true)}
        >
          {row.TotalTimeTaken}
        </td>
        <td>
            {row.StandardHours - row.TotalTimeTaken > 0
              ? `${row.StandardHours - row.TotalTimeTaken}hrs Less`
              : `${Math.abs(row.StandardHours - row.TotalTimeTaken)}hrs More`}
        </td>
      </tr>
      <TimeDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        timeEntry={row}
      />
    </>
  );
};

export default TaskTimeReportTableRow;
